import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {
  Divider,
  Grid,
  MenuItem,
  Typography,
  Autocomplete,
} from '@mui/material';
import {
} from '@mui/lab';
import {withStyles} from '@mui/styles';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';

import {
// createTyohyoPdf,
// getCodeFromGeneralPurposeMap,
// changeDateFormat,
// getErrorCode,
// API_CODE,
// getErrorMessages,
// getResponseResult,
// getDataFromGeneralPurposeMap,
// getMaxDeleteNum
} from '../../../../common/common.js';
// import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
// import MainContainer from '../../../organisms/MainContainer.js';
import {renderTextField, renderSelect} from '../../../atoms/CustomPart.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../../atoms/Buttons/BackButton.js';
// import DangerButton from '../../../../atoms/Buttons/DangerButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
// import {setSessionObject} from '../../../../common/Session.js';
import CustomAccordion from '../../../molecules/Accordion.js';
// import CustomBreadcrumbs from '../../../../molecules/Breadcrumbs.js';
import Modal from '@mui/material/Modal';
// import FooterButton from '../../../../organisms/FooterButton.js';
// import {
//   Link,
//   Breadcrumbs,
// } from '@mui/material';

const styles = (theme) => ({
  content: {
    'flexGrow': 1,
    'overflow': 'auto',
    'max-height': 'calc(100vh - 75px - 62px)',
    'height': 'auto',
    'padding': '15px 0 15px',
    'marginTop': '62px',
    'background': '#f5f5f5',
  },
  search: {
    'padding': '4px 0 16px 0',
  },
  button: {
    margin: '16px 10px 0 10px',
  },
  wave: {
    // fontSize: '1.2em',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%,-50%)',
  },
  fields: {
    'margin': '0px 10px 15px 10px',
  },
  textFieldDate: {
    margin: '0px 10px 15px 10px',
    width: '42%',
    minWidth: '100px',
  },
  tabPanel: {
    padding: 0,
  },
});

const autoCompleteItems = [
  {senroMskn: '北（ｷﾀｶﾝ）', code: 'A00001'},
  {senroMskn: 'ﾐﾅﾐｶﾝ', code: 'A00002'},
  {senroMskn: '東（ﾋｶｼｶﾝ）', code: 'A00003'},
  {senroMskn: 'ﾆｼｶﾝ', code: 'A00004'},
];

/**
 * 調査・点検箇所選択画面
 * 画面ID:SXXXXXX
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    // let _list = ['メニュー', '調査業種・理由入力票一覧', '調査業種・理由入力票'];
    // _list.push(GMN.PARCEL_SELECTION.name);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      // tabIndex: 1,
      // transitionList: _list,
    };

    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef?.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
      let data = {zigyoujo: 5160};
      this.props.doSetInitValues(data);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const data =[
      {nwJigyosyoCode: '広島北NWC', supplyPointNo: '1234567890123456789012', customerNo: '5100-190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerNameKana: '△△△△△', sectionNo: '00001', contractDate: '2023/01/01', transferDate: '2023/10/01', pillarDntNo: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '契約中', serviceMenu: '電灯定額接続送電サービス', previousSurveyyear: '2025', nextSurveyyear: '2025', previousSurveycode: '委託１', nextSurveycode: '委託２'},
      {nwJigyosyoCode: '広島北NWC', supplyPointNo: '1234567890123456789012', customerNo: '5100-190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerNameKana: '△△△△△', sectionNo: '00001', contractDate: '2023/01/01', transferDate: '2023/10/01', pillarDntNo: '12345', chousaGyousyu: 'プール', chousaReason: '漏えい電流の測定不能', hijikaCode: '高圧非自家(毎年調査)', keiyakuZyoukyou: '廃止中', serviceMenu: '電灯定額接続送電サービス', previousSurveyyear: '2025', nextSurveyyear: '2025', previousSurveycode: '委託１', nextSurveycode: '委託２'},
      {nwJigyosyoCode: '広島北NWC', supplyPointNo: '1234567890123456789012', customerNo: '5100-190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerNameKana: '△△△△△', sectionNo: '00001', contractDate: '2023/01/01', transferDate: '2023/10/01', pillarDntNo: '12345', chousaGyousyu: '浴場', chousaReason: '調査理由の取消', hijikaCode: '高圧非自家(隔年調査)', keiyakuZyoukyou: '供給遮断中', serviceMenu: '電灯定額接続送電サービス', previousSurveyyear: '2025', nextSurveyyear: '2025', previousSurveycode: '委託１', nextSurveycode: '委託２'},
      {nwJigyosyoCode: '広島北NWC', supplyPointNo: '1234567890123456789012', customerNo: '5100-190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerNameKana: '△△△△△', sectionNo: '00001', contractDate: '2023/01/01', transferDate: '2023/10/01', pillarDntNo: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '全使撤', serviceMenu: '電灯定額接続送電サービス', previousSurveyyear: '2025', nextSurveyyear: '2025', previousSurveycode: '委託１', nextSurveycode: '委託２'},
      {nwJigyosyoCode: '広島北NWC', supplyPointNo: '1234567890123456789012', customerNo: '5100-190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerNameKana: '△△△△△', sectionNo: '00001', contractDate: '2023/01/01', transferDate: '2023/10/01', pillarDntNo: '12345', chousaGyousyu: 'プール', chousaReason: '漏えい電流の測定不能', hijikaCode: '高圧非自家(毎年調査)', keiyakuZyoukyou: '契約中', serviceMenu: '電灯定額接続送電サービス', previousSurveyyear: '2025', nextSurveyyear: '2025', previousSurveycode: '委託１', nextSurveycode: '委託２'},
      {nwJigyosyoCode: '広島北NWC', supplyPointNo: '1234567890123456789012', customerNo: '5100-190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerNameKana: '△△△△△', sectionNo: '00001', contractDate: '2023/01/01', transferDate: '2023/10/01', pillarDntNo: '12345', chousaGyousyu: '浴場', chousaReason: '調査理由の取消', hijikaCode: '高圧非自家(隔年調査)', keiyakuZyoukyou: '契約中', serviceMenu: '電灯定額接続送電サービス', previousSurveyyear: '2025', nextSurveyyear: '2025', previousSurveycode: '委託１', nextSurveycode: '委託２'},
      {nwJigyosyoCode: '広島北NWC', supplyPointNo: '1234567890123456789012', customerNo: '5100-190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerNameKana: '△△△△△', sectionNo: '00001', contractDate: '2023/01/01', transferDate: '2023/10/01', pillarDntNo: '12345', chousaGyousyu: '寝たきり', chousaReason: '漏えい電流が1mA超過で未調査', hijikaCode: '非自家用', keiyakuZyoukyou: '契約中', serviceMenu: '電灯定額接続送電サービス', previousSurveyyear: '2025', nextSurveyyear: '2025', previousSurveycode: '委託１', nextSurveycode: '委託２'},
      {nwJigyosyoCode: '広島北NWC', supplyPointNo: '1234567890123456789012', customerNo: '5100-190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerNameKana: '△△△△△', sectionNo: '00001', contractDate: '2023/01/01', transferDate: '2023/10/01', pillarDntNo: '12345', chousaGyousyu: 'プール', chousaReason: '漏えい電流の測定不能', hijikaCode: '高圧非自家(毎年調査)', keiyakuZyoukyou: '契約中', serviceMenu: '電灯定額接続送電サービス', previousSurveyyear: '2025', nextSurveyyear: '2025', previousSurveycode: '委託１', nextSurveycode: '委託２'},
      {nwJigyosyoCode: '広島北NWC', supplyPointNo: '1234567890123456789012', customerNo: '5100-190000012', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerNameKana: '△△△△△', sectionNo: '00001', contractDate: '2023/01/01', transferDate: '2023/10/01', pillarDntNo: '12345', chousaGyousyu: '浴場', chousaReason: '調査理由の取消', hijikaCode: '高圧非自家(隔年調査)', keiyakuZyoukyou: '契約中', serviceMenu: '電灯定額接続送電サービス', previousSurveyyear: '2025', nextSurveyyear: '2025', previousSurveycode: '委託１', nextSurveycode: '委託２'},
    ];

    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true});
    // const values = this.props.values;
    // console.log(values);
    // await this.props.reset();
    let datas = {zigyoujo: '広島北NWC'};
    this.props.doSetInitValues(datas);
    const data =[];
    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    // try {
    //   const result = await this._searchOrder();
    //   if (!result) {
    //     return;
    //   }
    //   // 検索結果が0件の場合、エラーダイアログ表示
    //   if (!this.props.hasOwnProperty('orderList') ||
    //     !this.props.orderList ||
    //     this.props.orderList.length <= 0 ) {
    //     this.props.doShowMessage({
    //       message: 'CE0016',
    //     });
    //   }
    // } catch (error) {
    //   this.props.doShowMessage({
    //     message: 'TKSCS00001S',
    //     action: () => {
    //       this.props.history.push('/login');
    //     },
    //   });
    // }
    // this.gridRef = {}
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef?.current?.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'check',
      filterOn: true,
      headersVisibility: 'All',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      isDisplayCount: true,
      AddDeleteOn: false,
      style: {maxHeight: '300px', maxWidth: '100%', height: 'auto', width: 'auto'},
      isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
    };

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        <FlexGridColumnGroup binding="nwJigyosyoCode" header="NW事業所" dataType="String" width={120}/>
        <FlexGridColumnGroup binding="supplyPointNo" header="供給地点特定番号" dataType="String" width={200}/>
        <FlexGridColumnGroup binding="customerNo" header="ご契約番号" dataType="String" width={130}/>
        <FlexGridColumnGroup binding="customerName" header="お客さま名" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="customerNameKana" header="お客さま名カナ" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="sectionNo" header="ブロック番号" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="pillarDntNo" header="電柱番号" dataType="String" width={110}/>
        <FlexGridColumnGroup binding="contractDate" header="供給開始年月日" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="transferDate" header="異動年月日" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="hijikaCode" header="調査管理区分" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="chousaGyousyu" header="調査業種" dataType="String" width={110}/>
        <FlexGridColumnGroup binding="chousaReason" header="調査理由" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="keiyakuZyoukyou" header="契約状況" dataType="String" width={110}/>
        <FlexGridColumnGroup binding="serviceMenu" header="サービスメニュー" dataType="String" width={170}/>
      </CustomFlexGrid>
    );
  }

  /**
   * 線路名カナ イベント
   * @param {*} e イベント
   * @param {*} v 値
   */
  handleSenroNameChange = async (e, v) => {
    this.props.change('senroCode', '10001H');
  };

  /**
   * 戻る
   */
  doBack = () => {
    this.props.closeButton();
  };

  /**
   * 選択
   */
  doSelect = () => {
    let gridData = this.gridRef.current.selectedItem();
    this.props.selectButton(gridData);
  };

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    const {classes, values} = this.props;
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name="zigyoujo"
              component={renderSelect}
              className={classes.fields}
              label="NW事業所"
              fullWidth
              required={false}
              defaultValue={'5160'}
              initialValue={'5160'}
              validate={[
              ]}
              // InputProps={{
              //   readOnly: true,
              // }}
              // disabled
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北NWC'}</MenuItem>
              <MenuItem value={6120}>{'山口NWC'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="supplyPointNo" item xs={12} sm={2}>
            <Field
              id="supplyPointNo"
              name="supplyPointNo"
              component={renderTextField}
              className={classes.fields}
              label="供給地点特定番号"
              fullWidth
              type="text"
              required={false}
              validate={[
                validateRule.number,
                validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Grid key="customerNo" item xs={12} sm={2}>
            <Field
              id="customerNo"
              name="customerNo"
              // variant="standard"
              component={renderTextField}
              className={classes.fields}
              label="ご契約番号"
              fullWidth
              type="text"
              required={false}
              validate={[
              // validateRule.number,
              // validateRule.maxLength(22),
              ]}
            />
          </Grid>
          <Grid key="customerName" item xs={12} sm={2}>
            <Field
              id="customerName"
              name="customerName"
              component={renderTextField}
              className={classes.fields}
              label="お客さま名"
              fullWidth
              type="text"
              required={false}
              validate={[
              ]}
            />
          </Grid>
          <Grid key="customerNameKana" item xs={12} sm={2}>
            <Field
              id="customerNameKana"
              name="customerNameKana"
              // variant="standard"
              component={renderTextField}
              className={classes.fields}
              label="お客さま名カナ"
              fullWidth
              type="text"
              required={false}
              validate={[
              // validateRule.number,
              // validateRule.maxLength(22),
              ]}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="contractDateFrom" item xs={12} sm={2}>
            <Field
              id="contractDateFrom"
              name="contractDateFrom"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="供給開始年月日"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                validateRule.date,
                validateRule.correctFromDate(values ? values['contractDateTo'] : null),
              ]}
            />
          </Grid>
          <Typography sx={{margin: '18px 0px 20px 25px'}}>
            ～
          </Typography>
          <Grid key="contractDateTo" item xs={12} sm={2}>
            <Field
              id="contractDateTo"
              name="contractDateTo"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="供給開始年月日"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                validateRule.date,
                validateRule.correctDate(values ? values['contractDateFrom'] : null),
              ]}
            />
          </Grid>
          <Grid key="transferDateFrom" item xs={12} sm={2}>
            <Field
              id="transferDateFrom"
              name="transferDateFrom"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="異動年月日"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                validateRule.date,
                validateRule.correctFromDate(values ? values['transferDateTo'] : null),
              ]}
            />
          </Grid>
          <Typography sx={{margin: '18px 0px 20px 25px'}}>
        ～
          </Typography>
          <Grid key="transferDateTo" item xs={12} sm={2}>
            <Field
              id="transferDateTo"
              name="transferDateTo"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="異動年月日"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                validateRule.date,
                validateRule.correctDate(values ? values['transferDateFrom'] : null),
              ]}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="hijikaCode" item xs={12} sm={2}>
            <Field
              id="hijikaCode"
              name="hijikaCode"
              component={renderSelect}
              className={classes.fields}
              label="調査管理区分"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'非自家用'}</MenuItem>
              <MenuItem value={2}>{'高圧非自家(毎年調査)'}</MenuItem>
              <MenuItem value={3}>{'高圧非自家(隔年調査)'}</MenuItem>
              <MenuItem value={4}>{'低圧自家用'}</MenuItem>
              <MenuItem value={5}>{'調査拒否'}</MenuItem>
              <MenuItem value={6}>{'非自家の取消(自主的に自家用化)'}</MenuItem>
              <MenuItem value={7}>{'非自家の取消(増設50kW以上)'}</MenuItem>
              <MenuItem value={8}>{'非自家の取消(全使撤,低圧化)'}</MenuItem>
              <MenuItem value={9}>{'非自家の取消(その他)'}</MenuItem>
              <MenuItem value={10}>{'ＪＲ調査'}</MenuItem>
              <MenuItem value={11}>{'ＪＲ調査拒否'}</MenuItem>
              <MenuItem value={12}>{'ＮＴＴ拒否'}</MenuItem>

            </Field>
          </Grid>
          <Grid key="chousaGyousyu" item xs={12} sm={2}>
            <Field
              id="chousaGyousyu"
              name="chousaGyousyu"
              component={renderSelect}
              className={classes.fields}
              label="調査業種"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'寝たきり'}</MenuItem>
              <MenuItem value={3}>{'プール'}</MenuItem>
              <MenuItem value={4}>{'浴場'}</MenuItem>
              <MenuItem value={5}>{'学校等'}</MenuItem>
              <MenuItem value={6}>{'病院等'}</MenuItem>
              <MenuItem value={7}>{'老人福祉'}</MenuItem>
              <MenuItem value={8}>{'重要文化財'}</MenuItem>
              <MenuItem value={9}>{'学校でかつプール施設'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="chousaReason" item xs={12} sm={2}>
            <Field
              id="chousaReason"
              name="chousaReason"
              component={renderSelect}
              className={classes.fields}
              label="調査理由"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={'1'}>{'漏えい電流が1mA超過で未調査'}</MenuItem>
              <MenuItem value={'2'}>{'漏えい電流の測定不能'}</MenuItem>
              <MenuItem value={'3'}>{'調査理由の取消'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="blockNo" item xs={12} sm={4}>
            <Field
              id="blockNoFrom"
              name="blockNoFrom"
              label="ブロック番号"
              component={renderTextField}
              className="fields"
              type="text"
              sx={{width: '40%'}}
              InputProps={{
                readOnly: false,
              }}
            />
            <span className="wave">～</span>
            <Field
              id="blockNoTo"
              name="blockNoTo"
              label={<React.Fragment />}
              component={renderTextField}
              className="fields"
              type="text"
              sx={{width: '40%'}}
              InputProps={{
                readOnly: false,
              }}
            />
          </Grid>
          <Grid key="keiyakuZyoukyou" item xs={12} sm={2}>
            <Field
              id="keiyakuZyoukyou"
              name="keiyakuZyoukyou"
              // variant="standard"
              component={renderSelect}
              className={classes.fields}
              label="契約状況"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'契約中'}</MenuItem>
              <MenuItem value={2}>{'廃止中'}</MenuItem>
              <MenuItem value={3}>{'供給遮断中'}</MenuItem>
              <MenuItem value={4}>{'全使撤'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="serviceMenu" item xs={12} sm={4}>
            <Field
              id="serviceMenu"
              name="serviceMenu"
              // variant="standard"
              component={renderSelect}
              className={classes.fields}
              label="サービスメニュー"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'電灯定額接続送電サービス'}</MenuItem>
              <MenuItem value={2}>{'電灯標準接続送電サービス'}</MenuItem>
              <MenuItem value={3}>{'電灯時間帯別接続送電サービス'}</MenuItem>
              <MenuItem value={4}>{'電灯従量接続送電サービス'}</MenuItem>
              <MenuItem value={1}>{'高圧標準接続送電サービス'}</MenuItem>
              <MenuItem value={2}>{'高圧時間帯別接続送電サービス'}</MenuItem>
              <MenuItem value={3}>{'高圧臨時接続送電サービス'}</MenuItem>
              <MenuItem value={4}>{'高圧従量接続送電サービス'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="senroCode" item xs={12} sm={1}>
            <Field
              id="senroCode"
              name="senroCode"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="線路コード"
              fullWidth
              type="text"
              required={false}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid key="senroName" item xs={12} sm={3}>
            <Autocomplete
              ref={`autocomplete`}
              // freeSolo
              id="autocompleteSenroName"
              disableClearable
              options={autoCompleteItems.map((option) => option.senroMskn)}
              size='small'
              disabled={this.state.senroNameDisabled}
              fullWidth
              className="dntFields"
              // sx={{width: '320px'}}
              onBlur={this.handleSenroNameChange}
              renderInput={(params) => (
                <Field
                  id="senroName"
                  name="senroName"
                  component={renderTextField}
                  label="線路名"
                  required={false}
                  validate={[
                  ]}
                  {...params}
                />
              )}
            />
          </Grid>
          <Grid key="dntNo1" item xs={12} sm={1}>
            <Field
              id="dntNo1"
              name="dntNo1"
              component={renderTextField}
              className="dntFields"
              label="幹線"
              fullWidth
              type="text"
              required={false}
              // onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="dntNo2" item xs={12} sm={1}>
            <Field
              id="dntNo2"
              name="dntNo2"
              component={renderTextField}
              className="dntFields"
              label="第１分岐"
              fullWidth
              type="text"
              required={false}
              // onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="dntNo3" item xs={12} sm={1}>
            <Field
              id="dntNo3"
              name="dntNo3"
              component={renderTextField}
              className="dntFields"
              label="第２分岐"
              fullWidth
              type="text"
              required={false}
              // onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="dntNo4" item xs={12} sm={1}>
            <Field
              id="dntNo4"
              name="dntNo4"
              component={renderTextField}
              className="dntFields"
              label="第３分岐"
              fullWidth
              type="text"
              required={false}
              onChange={this.conditionChange}
              // sx={{width: '60px'}}
            />
          </Grid>
          <Grid key="bunki" item xs={12} sm={2}>
            <Field
              id="bunki"
              name="bunki"
              component={renderSelect}
              className="dntFields"
              label="分岐有無"
              fullWidth
              required={false}
              // onChange={this.conditionChange}
              sx={{width: '120px'}}
            >
              {/* {bunkiList} */}
              <MenuItem value={1}>{'分岐無'}</MenuItem>
              <MenuItem value={2}>{'分岐有'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // // フッタボタンを生成
    // const footerBtn = this.createBtnProps();
    // footerBtn[0].click = handleSubmit(() => this.doSelect());
    // footerBtn[0].disabled = this.state.buttonDisabled;
    // footerBtn[1].click = handleSubmit(() => this.doBack());

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <Modal
        open={this.props.modalOpen}
        style={{
          maxWidth: 1200,
          marginLeft: 'auto',
          marginRight: 'auto',
          overflow: 'visible',
        }}
      >
        <form noValidate autoComplete="off" className={classes.root}>
          <PaperPart className={classes.content}>
            <PaperPart className={classes.search}>
              <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              <Grid
                container
                justifyContent="right"
                alignItems="right"
                spacing={1}
              >
                <Grid key="clear" item>
                  <NegativeButton
                    id="clear"
                    variant="contained"
                    startIcon={<RotateLeftIcon />}
                    className={classes.button}
                    // size="large"
                    onClick={handleSubmit(this._reset)}
                  >
                    <span>クリア</span>
                  </NegativeButton>
                </Grid>
                <Grid key="search" item>
                  <PositiveButton
                    id="search"
                    variant="contained"
                    startIcon={<SearchIcon />}
                    className={clsx(classes.button)}
                    // size="large"
                    onClick={handleSubmit(this.doSearch)}
                  >
                    <span>検索</span>
                  </PositiveButton>
                </Grid>
              </Grid>
            </PaperPart>
            <div style={{marginBottom: '20px'}} />
            <Divider variant="middle" />
            <div style={{marginBottom: '4px'}} />
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Grid key="key1001List" item xs={12}>
                {this.renderTable()}
              </Grid>
            </Grid>
            <Grid key="keyBFE10112GFooter" item xs={12} style={{marginTop: '-20px'}}>
              {/* <FooterButton components={footerBtn} _props={this.props}/> */}
              <Grid
                container
                justifyContent="center"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid key="search" item>
                  <PositiveButton
                    id="search"
                    variant="contained"
                    className={clsx(classes.button)}
                    disabled={this.state.buttonDisabled}
                    // startIcon={<CheckCircle />}
                    // size="large"
                    onClick={handleSubmit(this.doSelect)}
                  >
                    <span>選択</span>
                  </PositiveButton>
                </Grid>
                <Grid key="search" item>
                  <NegativeButton
                    id="search"
                    variant="contained"
                    className={clsx(classes.button)}
                    startIcon={<KeyboardReturnIcon />}
                    // size="large"
                    onClick={handleSubmit(this.doBack)}
                  >
                    <span>閉じる</span>
                  </NegativeButton>
                </Grid>
              </Grid>
            </Grid>
            {/* </MainContainer> */}
          </PaperPart>
        </form>
      </Modal>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
  modalOpen: PropTypes.bool.isRequired,
  closeButton: PropTypes.func.isRequired,
  selectButton: PropTypes.func.isRequired,
  change: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    // initialValues: {
    //   dntNo1: '123',
    //   dntNo2: '456',
    //   dntNo3: '789',
    //   hikikomiDnt: '123',
    //   keiyakuNo1: '',
    //   jigyousyo: '456',
    //   states: '2',
    // },
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
